import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

export const UseIosCard = (props) => {
  const theme = useTheme()

  const handleOpenApp = () => {
    window.location.href = 'https://apps.apple.com/app/id6751843241';
  }

  return (
    <Card sx={{
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
      <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
              <DownloadDoneIcon color={"primary"} sx={{fontSize:50, color: theme.palette.primary.main}}/>
            </Avatar>
          }
          title="Information"
          subheader="Please use iOS App"
          titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
      />
      <CardContent sx={{mt:0, pt:0, pb:0}}>
        <Typography variant="body2" color="text.secondary">
          NFC is not available in Safari. Please open the iOS app to exchange data.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          color="primary"
          onClick={handleOpenApp}
        >
          Open App
        </Button>
      </CardActions>
    </Card>
  )
}

export default UseIosCard;
